import { render, staticRenderFns } from "./CustomOptionsSelectionField.vue?vue&type=template&id=6b94f096&scoped=true"
import script from "./CustomOptionsSelectionField.vue?vue&type=script&lang=js"
export * from "./CustomOptionsSelectionField.vue?vue&type=script&lang=js"
import style0 from "./CustomOptionsSelectionField.vue?vue&type=style&index=0&id=6b94f096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94f096",
  null
  
)

export default component.exports